import { MapDrawingMode } from '../../enums';
import Polygon from './entities/Polygon';

export default class DrawEntityFactory {
  static getDrawEntity(mode) {
    const drawEntityByMode = {
      [MapDrawingMode.Polygon]: Polygon,
    };
    const DrawEntity = drawEntityByMode[mode];

    if (!DrawEntity) {
      throw new Error('Unsupported drawing shape');
    }

    return DrawEntity;
  }
}
